import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import '../styles/components/_musiccatalog.scss';

const months = ['use 1 - 12', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const MusicCatalogList = (props) => {
	const releaseFormats = ['single', 'EP', 'LP'];
	const artists = ['Jesse Rivest', 'Jessellaneous'];
	const defaultArtists = ['Jesse Rivest'];

	const [isShowFilters, setIsShowFilters] = useState(false);
	const [releaseFormatsChecked, setReleaseFormatsChecked] = useState(releaseFormats);
	const [artistsChecked, setArtistsChecked] = useState(defaultArtists);

	const filteredMusicCatalogItems = props.children.filter(
		(musicCatalogItem, i) => {
			return artistsChecked.includes(musicCatalogItem.props.artist) && releaseFormatsChecked.includes(musicCatalogItem.props.category);
		}
	);

	function handleClickShowHideFilters () {
		setIsShowFilters(!isShowFilters);
	}

	function handleCheckReleaseFormat (releaseFormat) {
		const iPos = releaseFormatsChecked.indexOf(releaseFormat);
		if (iPos < 0) {
			setReleaseFormatsChecked([...releaseFormatsChecked, releaseFormat]);
		} else {
			const newReleaseFormatsChecked = [...releaseFormatsChecked];
			newReleaseFormatsChecked.splice(iPos, 1);
			setReleaseFormatsChecked(newReleaseFormatsChecked);
		}
	}

	function handleCheckArtist (artist) {
		const iPos = artistsChecked.indexOf(artist);
		if (iPos < 0) {
			setArtistsChecked([...artistsChecked, artist]);
		} else {
			const newArtistsChecked = [...artistsChecked];
			newArtistsChecked.splice(iPos, 1);
			setArtistsChecked(newArtistsChecked);
		}
	}

	useEffect(() => {
		const handleEsc = (event) => {
			if (event.key === 'Escape') {
				setIsShowFilters(false);
			}
		};
		window.addEventListener('keydown', handleEsc);

		return () => {
			window.removeEventListener('keydown', handleEsc);
		};
	}, []);

	return (
		<div>
			<p>
				<span className="italic">Some releases are hidden by default.</span><br />
				Click on the filter element below to change what is visible/hidden.
			</p>
			<p className="card">
				<button className="card MusicCatalogList__toggleFilters" onClick={handleClickShowHideFilters} onKeyDown={handleClickShowHideFilters}>
					Click to show/hide filters
				</button>
			</p>
			<p className="MusicCatalogList__filteredCounter">
				Showing {filteredMusicCatalogItems.length} of {props.children.length} total releases
			</p>

			{isShowFilters && (
				<div className="MusicCatalogList__filters">

					<form id="filterReleaseFormat">
						<fieldset>
							<legend>
								ReleaseFormat
							</legend>
							<label>
								<input type="button" name="resetReleaseFormat"
									onClick={() => setReleaseFormatsChecked(releaseFormats)} onKeyDown={() => setReleaseFormatsChecked(releaseFormats)}
									className="MusicCatalogList__filters__reset"
								/>
								Reset
							</label>
							{releaseFormats.map(
								(releaseFormat, i) => (
									<label key={i}>
										<input type="checkbox" name={releaseFormat} checked={releaseFormatsChecked.includes(releaseFormat)}
											onChange={() => handleCheckReleaseFormat(releaseFormat)}
										/>
										{releaseFormat}
									</label>
								)
							)}
						</fieldset>
					</form>

					<form id="filterArtist">
						<fieldset>
							<legend>
								Artist
							</legend>
							<label>
								<input type="button" name="resetArtist"
									onClick={() => setArtistsChecked(artists)} onKeyDown={() => setArtistsChecked(artists)}
									className="MusicCatalogList__filters__reset"
								/>
								Reset
							</label>
							{artists.map(
								(artist, i) => (
									<label key={i}>
										<input type="checkbox" name={artist} checked={artistsChecked.includes(artist)}
											onChange={() => handleCheckArtist(artist)}
										/>
										{artist}
									</label>
								)
							)}
						</fieldset>
					</form>

				</div>
			)}

			<div className="MusicCatalogList p">
				{filteredMusicCatalogItems}
			</div>
		</div>
	);
};

const MusicCatalogItem = ({children: image, title, year, month, category, catnum, width, url}) => (
	<div className="MusicCatalogItem" style={{width: width + 'px'}}>
		{image}
		<CatalogItemTitle url={url}>
			{title}
		</CatalogItemTitle>
		<CatalogItemYear>
			{months[month]} {year}
		</CatalogItemYear>
		<CatalogItemCategory>
			{category}
		</CatalogItemCategory>
		<CatalogItemNumber>
			{catnum}
		</CatalogItemNumber>
	</div>
);

const CatalogItemTitle = (props) => (
	<div className="CatalogItemTitle">
		<Link to={props.url}>{props.children}</Link>
	</div>
);

const CatalogItemYear = (props) => (
	<div className="CatalogItemYear">
		{props.children}
	</div>
);

const CatalogItemCategory = (props) => (
	<div className="CatalogItemCategory">
		{props.children}
	</div>
);
const CatalogItemNumber = (props) => (
	<div className="CatalogItemNumber">
		{props.children}
	</div>
);

export {MusicCatalogList, MusicCatalogItem, CatalogItemTitle, CatalogItemYear, CatalogItemCategory, CatalogItemNumber};
